export const removeDuplicates = (array, attribute) =>
  array.filter(
    (v, i, a) => a.findIndex((v2) => v2[attribute] === v[attribute]) === i
  );
